import axios from 'axios';
import { useAuthStore } from '@/store/auth';
import { getApiUrl } from '@/config/config';

// 硬编码API URL，使用域名而不是IP
const API_URL = 'https://aivitahelper.xyz:8081/api/vip';

export interface VipRedeemResponse {
  code: number;
  message: string;
  data?: any;
}

export const vipService = {
  /**
   * 兑换VIP码
   * @param code 兑换码
   * @returns Promise<VipRedeemResponse>
   */
  async redeemVipCode(code: string): Promise<VipRedeemResponse> {
    const authStore = useAuthStore();
    try {
      const response = await axios.post(
        `${API_URL}/redeem`,
        { code },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authStore.token}`
          }
        }
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      throw error;
    }
  }
}; 